module.exports = __webpack_public_path__ + "img/icon-idcard.4a8fa5c2.png";